import {useEffect, useState} from 'react';
import ActionModal from 'components/ActionModal';
import ButtonBigWithAction from 'elements/ButtonBigWithAction';
import DeleteRequest from 'components/DeleteRequest'
import LoadingIndicator from 'pages/LoadingIndicator';

const DeleteDraft = ({isOpen, isOpenAction, updateStatus, updatedAction, selectedData}) => {
    const [invoice, setInvoice] = useState({name: null, id: null})
    useEffect(() => {
        if(selectedData) {
            setInvoice({name: selectedData.customerName, id: selectedData.id})           
        } else {
            setInvoice({name: null, id: null})
        }
    }, [selectedData])

    const [deleteStatus, setDeleteStatus] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleDelete = (data) => {
        setLoading(true)
        DeleteRequest('api/invoices/draft/'+invoice.id)
            .then(response => {
                const successMessage = (
                    <div className='text-sm text-green-100 bg-green-600 text-bold mb-2 p-1'>
                        <p>Şablon başarıyla silindi.</p> 
                    </div>
                )
                setDeleteStatus(successMessage)
                setLoading(false)
                updatedAction(!updateStatus)
            })
            .catch(error => {
                const err = error.response.data.errors
                if(err) {
                    const errorItems = Object.keys(err).map((value, index) => {
                        return (
                            <li key={value.toString()}>{err[value][0]}</li>
                        )
                    })
                    const errorMessage = (
                        <div className='text-sm text-red-600'>
                            <p>{error.response.data.message}</p>   
                            <ul className='list-[circle] list-inside'>
                                {errorItems}
                            </ul>                     
                        </div>
                    )

                    setDeleteStatus(errorMessage)
                } else {
                    const errorMessage = (
                        <div className='text-sm text-red-100 bg-red-600 text-bold mb-2 p-1'>
                            <p>{`${error.response.statusText} (${error.response.status})`}</p> 
                        </div>
                    )   
                    
                    setDeleteStatus(errorMessage)
                }                
                
                setLoading(false)
            })
    }

    const actions = (
        <>
            {!deleteStatus && <ButtonBigWithAction type="button" addClass="text-white bg-emerald-500" title="Sil" onClick={handleDelete}/>}
        </>
    )

    return (
        <ActionModal isOpen={isOpen} 
                    isOpenAction={isOpenAction} 
                    id="draftDeleteModal" 
                    title="Şablon Faturayı Sil" 
                    cancelButton={true} 
                    actions={actions}
                    actionsForClear={[setDeleteStatus]}>
            <div>
                {deleteStatus}
            </div>
            <div className=''>                
                {!deleteStatus && <p className='text-md text-gray-700'><span className='font-semibold underline'>{invoice.name}</span> isimli müşteriye ait şablonu silmek istediğinize emin misiniz?</p>}
            </div>
            {loading && <LoadingIndicator />}
        </ActionModal>
    );
};

export default DeleteDraft;
